class ScannedDocument {
  constructor({
    id = '',
    fileName = '',
    template = '',
    mysqlId = '',
    createdAt = '',
    supplier = '',
    model = '',
    docket_number = '',
    validated = '',
    residual = '',
    isLotified = false,
    isAssayed = false,
    arriving_date = '',
    laboratoryNote = {},
    camFileName = '',
  }) {
    this.id = id;
    this.fileName = fileName;
    this.template = template;
    this.mysqlId = mysqlId;
    this.createdAt = createdAt;
    this.supplier = supplier;
    this.model = model;
    this.docket_number = docket_number;
    this.validated = validated ? 'yes' : 'no';
    this.residual = residual ? 'yes' : 'no';
    this.isLotified = isLotified;
    this.isAssayed = isAssayed;
    this.arriving_date = arriving_date;
    this.laboratoryNote = laboratoryNote;
    this.camFileName = camFileName;
  }
}

export default ScannedDocument;
